import { computed } from 'vue'
import { type Duration, intervalToDuration } from 'date-fns'
import { storeToRefs } from 'pinia'
import { useTimeStore } from '@/stores/time'

type CountUp = 'up'
type CountDown = 'down'

export type TimerMode = CountUp | CountDown

interface TimeOptions {
  startAt?: Date
  endAt?: Date
}

function useTimer(timerMode: TimerMode, timeOptions: TimeOptions) {
  const { currentTime } = storeToRefs(useTimeStore())

  const startTime = computed(() => timeOptions.startAt ?? null)
  const endTime = computed(() => timeOptions.endAt ?? null)

  function computeCountdown() {
    if (!endTime.value) return null
    if (currentTime.value >= endTime.value) {
      return { hours: 0, minutes: 0, seconds: 0 }
    }
    return intervalToDuration({ start: currentTime.value, end: endTime.value })
  }

  function computeCountup() {
    if (!startTime.value) return null
    if (currentTime.value <= startTime.value) {
      return { hours: 0, minutes: 0, seconds: 0 }
    }
    return intervalToDuration({ start: startTime.value, end: currentTime.value })
  }

  const duration = computed<Duration | null>(() => {
    return timerMode === 'down' ? computeCountdown() : computeCountup()
  })

  return {
    duration
  }
}

export default useTimer
